import { render, staticRenderFns } from "./BodyNavSidebar.vue?vue&type=template&id=12853abe&"
import script from "./BodyNavSidebar.vue?vue&type=script&lang=js&"
export * from "./BodyNavSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports